import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/common.scss';
import './plugins/element-ui';
import './assets/css/element-ui/element-variables.scss';  //主题色
import i18n from './plugins/vue-i18n';  //国际化
import './directives';  //自定义指令
import './filters';  //自定义过滤器
import './permission';  //权限问题

// import '@/assets/css/iconfont.css';
import SlideVerify from "vue-monoplasty-slide-verify";
import VueClipboard from 'vue-clipboard2'
import echarts from './utils/echarts';
Vue.use(SlideVerify);
Vue.use(echarts)
Vue.use(VueClipboard)
Vue.config.productionTip = false
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
